import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { IonContent, IonPage, IonSpinner } from "@ionic/react";

import { socialActions } from "../../api/SocialActions";
import { toastAdd } from "../../components/CustomToast/CustomToasts";
import AuthContext from "../../context/AuthContext";
import { useWindowSize } from "../../hooks/useWindowSize";
import { getValueOfSearchedUrlQueryParameter } from "../../utils/globalFunctions";

const SocialLinkPage: React.FC = () => {
  const { layout } = useWindowSize();
  const { isLoggedIn } = useContext(AuthContext);
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    const socialId = getValueOfSearchedUrlQueryParameter("socialId");
    const platform = getValueOfSearchedUrlQueryParameter("platform");

    if (!socialId || !platform) {
      history.replace(isLoggedIn ? "/" : "/login");
      return;
    }

    if (isLoggedIn) {
      socialActions
        .addSocialId(socialId, platform)
        .then(() => {
          socialActions.notifySyncConfirmedForPlatform(socialId, platform);
          toastAdd(t("social.linked"), "success");

          history.replace("/");
        })
        .catch(() => {
          toastAdd(t("err.__"), "error");
          history.replace("/");
        });
    } else {
      localStorage.setItem(
        "pendingSocialLink",
        JSON.stringify({ socialId, platform })
      );
      toastAdd(t("social.loginRequired"), "info");
      history.replace("/login");
    }
  }, []);

  return (
    <IonPage className={`layout--${layout}`}>
      <IonContent className="ion-padding ion-text-center">
        <IonSpinner name="circles" color="primary" />
      </IonContent>
    </IonPage>
  );
};

export default SocialLinkPage;
